var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMediumCup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 28,
    viewBox: "0 0 19 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Medium cup"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Medium Cup"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Cup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.25011 5.90863H1.32568L3.5 27.75H9.25011H15L17.1745 5.90863H9.25011Z",
    fill: "#FAF4E9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.9203 3.33722H0.579669C0.259146 3.33722 0 3.59392 0 3.91015V5.33519C0 5.65198 0.259714 5.90812 0.579669 5.90812H17.9203C18.2409 5.90812 18.5 5.65142 18.5 5.33519V3.91015C18.5 3.59841 18.2403 3.33722 17.9203 3.33722Z",
    fill: "#503D31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.6841 0.75H9.25036H2.81659L1.32593 3.33719H9.25036H17.1748L15.6841 0.75Z",
    fill: "#FAF4E9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Label"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M3.5 27.75H15L16.5 13.75C11.3326 14.5793 7.24736 14.5822 2 13.75L3.5 27.75Z",
    fill: "#C07039"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Shadow",
    d: "M17.0546 6.79106L17.1745 5.90863H1.32568",
    fill: "#D8C8B4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1",
    d: "M14 14.25C14.0319 14.0656 14.7815 13.9538 16.5 13.75L15 27.75H13.5L14 14.25Z",
    fill: "#9F5B2C"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumCup);
export default __webpack_public_path__ + "static/media/medium-cup.4be9d0b78877d6307214b0857d16726c.svg";
export { ForwardRef as ReactComponent };